<template>
  <material-card
          icon="file_copy"
          :color="$vuetify.theme.themes.light.secondary"
          :title="
            $t('components.employers.employer_details.employer_documents')
          "
          v-if="provider"
        >
          <v-card-text>
            <pbas-data-table
              :exporters="$exporters"
              ref="employerFilesTable"
              :dataProvider="provider"
              fileNamePrefix="employerFiles"
              :identifier="'employerFilesTable' + selectedPlan.Id"
              :show-select="false"
              @error="error = $event"
              :rowActions="rowActions"
            ></pbas-data-table>
          </v-card-text>
          <error-handler :error="error"></error-handler>
        </material-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ErrorHandler from "@/components/ErrorHandler";
import { InMemoryProvider } from "pbas-vue-components";
import EmployerFilesHeaders from "@/headers/InMemoryEmployerFiles";
export default {
  props: ["id"],
  components: {
    ErrorHandler,
  },
  data() {
    return {
      error: null,
      provider: undefined,
      selectedItem: null,
       rowActions: [
        // {
        //   name: "downloadFiles",
        //   icon: "file_download",
        //   color: "#00a5d7",
        //   title: "globals.download",
        //   handler: (item) => this.downloadFiles(item),
        // },
      ],
    };
  },
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("plansMembers", ["planOptions"]),
  },
  mounted() {
    console.log("mounted employer files table component", this.selectedPlan);
    if (this.selectedPlan !== null && this.selectedPlan !== undefined) {
      this.loadData();
    }
  },
  methods: {
    ...mapActions("plansMembers", [
      "getPlanEmployerFiles",
    ]),
    async loadData() {
      try {
        let files = (await this.getPlanEmployerFiles({
        planIdentityId: this.selectedPlan.Id,
        employerIdentityId: this.id,
      })).data.value;
      this.provider = undefined;
      this.$nextTick(() => {
      this.provider = new InMemoryProvider(
          files,
          EmployerFilesHeaders
        );
      });
      } catch (error) {
        this.error =error;
      }
    },
  },
};
</script>
